import { Button, type ButtonProps } from '@heidi/design-system/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@heidi/design-system/tooltip';
import type { LucideIcon } from 'lucide-react';

export type HeaderIconButtonProps = {
  label: string;
  icon: LucideIcon;
  'data-testid'?: string;
} & Pick<ButtonProps, 'onClick' | 'aria-expanded'>;

export const HeaderIconButton = ({
  label,
  icon: Icon,
  ...buttonProps
}: HeaderIconButtonProps) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <Button
        variant="ghost"
        size="sm"
        iconOnly
        className="text-text-primary"
        aria-label={label}
        {...buttonProps}
      >
        <Icon aria-hidden />
      </Button>
    </TooltipTrigger>
    <TooltipContent side="bottom">{label}</TooltipContent>
  </Tooltip>
);
